import Papa from 'papaparse'

export default function createCsvAndDownload(
  fileName: string,
  data: unknown[],
  options?: { columns?: string[] }
) {
  const csv = Papa.unparse(
    data,
    options?.columns ? { columns: options.columns } : undefined
  )
  const anchor = document.createElement('a')
  anchor.href = 'data:attachment/csv' + ',' + encodeURI(csv)
  anchor.target = '_self'
  anchor.rel = 'noopener'
  anchor.download = fileName
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
}
